import { NamedDefinitionPage } from './NamedDefinitionPage';

export function RepresentativeGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/representativegroups"
      listRoute="/representative-groups"
      title="Temsilci Grubu"
      subtitle="Temsilci grubu kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Grup Kodu"
      descriptionLabel="Açıklama"
      descRequired
      newLabel="Yeni Temsilci Grubu"
      exportName="temsilci-gruplari"
      entityLabel="temsilci grubu"
    />
  );
}
